import { LiveChatAppSettingsFormValues } from "../types";
import { resolveLiveChatAppSettings } from "./resolveLiveChatAppSettings";

export const transformLiveChatAppSettingsToFormValues = (
  settingsObject: unknown
): LiveChatAppSettingsFormValues => {
  const resolvedSettings = resolveLiveChatAppSettings(settingsObject);

  return {
    browserTabTitle: resolvedSettings.browserTabTitle,
    faviconUrl: resolvedSettings.faviconUrl || null,
    businessName: resolvedSettings.businessName,
    businessLogoUrl: resolvedSettings.businessLogoUrl || null,
    agentName: resolvedSettings.agentName,
    agentImage: resolvedSettings.agentImage || null,
    welcomeMessage: resolvedSettings.ctaTitle,
    theme: "light",
    senderMessageBackgroundColor: resolvedSettings.senderMessageBackgroundColor,
    ctas: [resolvedSettings.ctaTitle, resolvedSettings.ctaSubtitle],
    ctaVisual: resolvedSettings.ctaVisual
      ? resolvedSettings.ctaVisual.id.startsWith("default")
        ? resolvedSettings.ctaVisual.id
        : resolvedSettings.ctaVisual.url
      : null,
    customButton: resolvedSettings.customButton ?? { title: "", url: "" },
    suggestions: Array.from({ length: 6 }, (_, index) => ({
      id: `suggestion-${index + 1}`,
      value: resolvedSettings.suggestions[index] ?? "",
    })),
  };
};
